import props from '../layoutProps';
import image from '../../../../../static/learning-early@large.jpg';

const key = 'early-years';

export default {
  ...props,
  rootNavKey: [...props.rootNavKey, key],
  parentKeys: [...props.parentKeys, key],
  image,
};
